import { Injectable } from "@angular/core"
import { LmApiService } from "./lm-api.service"
import { map } from "rxjs/operators"
import ResourceCardModel from "../models/card-model/resourceCard.model"
import CollectionCardModel from "../models/card-model/collectionCard.model"

@Injectable({
    providedIn: "root",
})
export class StudentService {
    constructor(private lmApi: LmApiService) {}

    public getTopPicks() {
        return this.lmApi.getWithCookiesInParams("/api/v2/student-top-picks/").pipe(
            map((res: any) => {
                return res.picks.map((obj) => {
                    if (obj.type === "resource") {
                        return ResourceCardModel.fromData(obj.data)
                    } else {
                        return CollectionCardModel.fromData(obj.data)
                    }
                })
            })
        )
    }

    public getPopular() {
        return this.lmApi.getWithCookiesInParams("/api/v2/student-popular-resources/").pipe(
            map((res: any) => {
                return res.results.slice(0, 3).map((obj) => {
                    return ResourceCardModel.fromData(obj)
                })
            })
        )
    }
}
